// employee.js (Service File)
// Thin wrapper around the existing GET /users endpoint, shared by any
// module that needs an employee picker (e.g. Payroll's Pay Basis / Wage
// Rate screens) instead of every module re-implementing the same call.
import axiosInstance from "../Axios";

function getEmployees(params = {}) {
  try {
    return axiosInstance.get("/users", { params });
  } catch (error) {
    console.log("Error while fetching employees:", error);
    throw error;
  }
}

export { getEmployees };
